import FileAPI from "fileapi"

var fileapiUploader = function (params) {
  // console.log("params: ", params)

  var core = {
    imgFun: function () {
      var promise = new Promise(function (resolve, reject) {
        var operation = params.operation || "",
          url = params.url || "",
          files = params.files || [],
          width = params.width || 0,
          height = params.height || 0

        if (url == "") {
          reject("上传路径错误")
        }
        if (operation == "preview") {
          var htmlCanvas = [],
            len = files.length
          for (var file of files) {
            if (/^image/.test(file.type)) {
              FileAPI.Image(file)
                .preview(width, height)
                .rotate("auto")
                .get(function (err, img) {
                  if (!err) {
                    htmlCanvas.push(img)
                    if (htmlCanvas.length == len) {
                      resolve(htmlCanvas) //所有图片处理完再触发
                    }
                  }
                })
            }
          }
        }
        if (operation == "upload") {
          var obj = {
            successFiles: [],
            failedFiles: [],
          }
          var filesCount = files.length
          for (var file of files) {
            FileAPI.upload({
              url: url,
              files: { img: file },
              data: {
                agency_uid: params.agency_uid || "",
                currentFile: file,
              },
              upload: function () {},
              progress: function (evt) {
                var pr = ((evt.loaded / evt.total) * 100).toFixed(2) + "%"
              },
              complete: function (err, xhr) {
                if (err) {
                  obj.failedFiles.push({
                    name: this.data.currentFile.name,
                    msg: "上传失败",
                  })
                } else {
                  var result = JSON.parse(xhr.responseText) || {},
                    data = result.data || {}

                  if (result.ret == 0) {
                    obj.successFiles.push(data)
                  } else {
                    obj.failedFiles.push({
                      name: this.data.currentFile.name,
                      msg: result.msg || "上传失败",
                    })
                  }
                }

                if (obj.successFiles.length + obj.failedFiles.length == filesCount) {
                  resolve(obj) //所有图片处理完再触发
                }
              },
            })
          }
        }
      })
      return promise
    },
  }
  return core.imgFun()
}
export default fileapiUploader
